/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import {
  type ApiImageBackground,
  ApiImageBackgroundSchema,
  type ApiMonochromeBackground,
  ApiMonochromeBackgroundSchema,
} from './background'
import { type CmsButtonApiProps, CmsButtonApiPropsSchema } from './cms-button'
import {
  type RelatedLinkApiProps,
  RelatedLinkApiPropsSchema,
} from './related-links-content'
import type { RichText } from './rich-text'

/* TypeScript */
export type SectionBannerBackgroundApiProps = {
  sectionBannerImageBackground?: ApiImageBackground
  sectionBannerMonochromeBackground?: ApiMonochromeBackground
}

export type SectionBannerApiProps = {
  title?: string
  titleV2?: RichText
  technicalName?: string
  description?: string
  descriptionV2?: RichText
  button?: CmsButtonApiProps
  relatedLinks?: RelatedLinkApiProps
  additionalSpacing?: 'Top' | 'Bottom' | 'Top-Bottom' | 'None'
} & SectionBannerBackgroundApiProps

/* Schemas */
export const SectionBannerBackgroundApiPropsSchema = z.object({
  sectionBannerImageBackground: ApiImageBackgroundSchema.optional(),
  sectionBannerMonochromeBackground: ApiMonochromeBackgroundSchema.optional(),
})

export const SectionBannerApiPropsSchema = z
  .object({
    title: z.string().optional(),
    titleV2: LooseRichTextSchema.optional(),
    technicalName: z.string().optional(),
    description: z.string().optional(),
    descriptionV2: LooseRichTextSchema.optional(),
    button: CmsButtonApiPropsSchema.optional(),
    relatedLinks: RelatedLinkApiPropsSchema.optional(),
    additionalSpacing: z
      .enum(['Top', 'Bottom', 'Top-Bottom', 'None'])
      .optional(),
  })
  .and(SectionBannerBackgroundApiPropsSchema)

/* Schemas validation */
type TestSectionBannerApiProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<SectionBannerApiProps>,
    z.infer<typeof SectionBannerApiPropsSchema>
  >
>
